





























































































































































import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";
import WalletKey from "@/components/wallet-key";
import InformationKey from "@/components/information-key";
import NoticeKey from "@/components/notice-key";
import CyuricaWalletKey from "@/components/cyurica-wallet-key";
import _ from "lodash";
import AnnouncementDialog from "@/components/templates/Common/AnnouncementDialog.vue";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }

    const informationStore = inject(InformationKey);
    if (!informationStore) {
      throw new Error(`${InformationKey} is not provided`);
    }

    const noticeStore = inject(NoticeKey);
    if (!noticeStore) {
      throw new Error(`${NoticeKey} is not provided`);
    }

    const cyuricaWalletStore = inject(CyuricaWalletKey);
    if (!cyuricaWalletStore) {
      throw new Error(`${cyuricaWalletStore} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const member = computed(() => memberStore.member);
    const loginInfo = computed(() => memberStore.loginInfo);
    const isPinLocked = computed(() => memberStore.isPinLocked);
    const pinRequestExistsFlag = computed(
      () => memberStore.pinRequestExistsFlag
    );
    const memberResponse = computed(() => memberStore.response);

    const walletLoading = computed(() => walletStore.loading);
    const walletResponse = computed(() => walletStore.response);
    const walletList = computed(() => walletStore.walletList);

    const informationHeaders = computed(
      () => informationStore.informationHeaders
    );
    const informationList = computed(() => informationStore.informationList);
    const informationResponse = computed(() => informationStore.response);

    const noticeHeaders = computed(() => noticeStore.noticeHeaders);
    const companyNoticeList = computed(() => noticeStore.companyNoticeList);

    const cyuricaWalletResponse = computed(() => cyuricaWalletStore.response);

    const toHistory = (companyCode: string) => {
      context.root.$router.push({
        name: "MemberHistory",
        query: { code: companyCode }
      });
    };
    const linkToInformation = (row: any) => {
      context.root.$router.push({
        name: "MemberInformationDetail",
        params: { id: row.id }
      });
    };
    const linkToNotice = (row: any) => {
      context.root.$router.push({
        name: "MemberCompanyNotice",
        params: { company_code: row.company_code, id: row.key }
      });
    };
    const setDrawAccount = async (companyCode: string) => {
      walletStore.clearResponse();
      displayuiStore.clearErrorSnackBar;
      displayuiStore.clearSuccessSnackBar;
      walletStore.setAuthorizationHeader(accessToken.value);
      await walletStore.setDrawAccount(companyCode);
      if (walletResponse.value.status >= 400) {
        if (
          walletResponse.value.status == 400 ||
          walletResponse.value.status == 404
        ) {
          // メッセージがあれば表示
          if (
            walletResponse.value.data.messages &&
            walletResponse.value.data.messages.length > 0
          ) {
            displayuiStore.showErrorSnackBar(
              walletResponse.value.data.messages[0]
            );
            return;
          }
        }

        displayuiStore.showErrorSnackBar("引き落とし先の変更に失敗しました。");
      }
      if (walletResponse.value.status < 400) {
        walletStore.getWalletList(); // 口座再取得
        displayuiStore.showSuccessSnackBar("引き落とし先を変更しました。");
      }
    };

    const confirmIsConsented = async () => {
      cyuricaWalletStore.clearResponse();
      displayuiStore.clearErrorSnackBar;
      await cyuricaWalletStore.getIsConsented();
      if (cyuricaWalletResponse.value.status == 404) {
        context.root.$router.push({ name: "MemberWalletConsent" });
      } else if (cyuricaWalletResponse.value.status >= 400) {
        displayuiStore.showErrorSnackBar("エラーが発生しました。");
      } else {
        context.root.$router.push({ name: "MemberWalletCharge" });
      }
    };

    const loadedFlag = ref<boolean>(false);

    onMounted(async () => {
      loadedFlag.value = false;
      walletStore.clearResponse();
      cyuricaWalletStore.clearResponse();
      displayuiStore.openOverlayLoading();
      memberStore.setAuthorizationHeader(accessToken.value);
      walletStore.setAuthorizationHeader(accessToken.value);
      informationStore.setAuthorizationHeader(accessToken.value);
      noticeStore.setAuthorizationHeader(accessToken.value);
      cyuricaWalletStore.setAuthorizationHeader(accessToken.value);
      await walletStore.getWalletList();
      await memberStore.getLoginInfo();
      noticeStore.clearCompanyNoticeList();
      for (let index = 0; index < walletList.value.length; index++) {
        noticeStore.getCompanyNoticeList(walletList.value[index]['company_code_item']['internal_value']);
      }

      const p1 = memberStore.getIsPinLocked();
      const p2 = memberStore.getPinRequestExists();
      const p3 = memberStore.getMember();
      const p4 = informationStore.getInformationCategoryList();

      await Promise.allSettled([p1, p2, p3, p4]);

      if (
        memberResponse.value.status < 400 &&
        informationResponse.value.status < 400
      ) {
        await informationStore.getInformationList();
        informationStore.setNewInformationFlag(member.value.checked_notice_id); // 表示ステータス更新
      }

      loadedFlag.value = true;
      displayuiStore.closeOverlayLoading();
    });

    return {
      _,
      toHistory,
      walletList,
      loadedFlag,
      member,
      loginInfo,
      informationHeaders,
      informationList,
      linkToInformation,
      noticeHeaders,
      companyNoticeList,
      linkToNotice,
      setDrawAccount,
      confirmIsConsented,
      walletLoading,
      isPinLocked,
      pinRequestExistsFlag
    };
  },
  components: {
    AnnouncementDialog
  }
});
